import React from 'react';
import { Modal, Input , Select, InputNumber, message } from 'antd';
import IconGhostBtn from './IconGhostBtn'
import { TransparentColors } from '../../utility/ColorPalette';

class IconInputButton extends React.Component {
  state = {
    open: false,
    inputValue: this.props.initialValue || '',
    maxCapacityValue: this.props.initialMaxCapacity || null,
    colorValue: this.props.initialColor || null
  };

  showModal = (e) => {
    e.stopPropagation();
    this.setState({
      open: true,
      inputValue: this.props.initialValue || '',
      maxCapacityValue: this.props.initialMaxCapacity || null,
      colorValue: this.props.initialColor || null,
    });
  };

  handleOk = (e) => {
    e.stopPropagation();
    const { onConfirm, id } = this.props;
    const { inputValue, maxCapacityValue, colorValue } = this.state;

    // ✅ Validación: todos los campos son obligatorios
    if (!inputValue || maxCapacityValue === null || !colorValue
    ) {
      // Aquí puedes mostrar un mensaje de error o notificación
      message.error('Todos los campos del formulario son obligatorios');
      return; // 👈 no ejecuta onConfirm
    }

    // Si todo está bien, ejecuta la función
    if (onConfirm) {
      onConfirm(id, inputValue, maxCapacityValue, colorValue);
    }
    this.setState({ open: false });
  };

  handleCancel = (e) => {
    e.stopPropagation();
    this.setState({ open: false });
  };

  handleChangeInput = (e) => {
    e.stopPropagation();
    this.setState({ inputValue: e.target.value });
  };
  handleChangeNumber = (value) => {
    this.setState({ maxCapacityValue: value });
  };

  handleChangeSelect = (value) => {
    this.setState({ colorValue: value });
  };
  stopEvent = (e) => {
    e.stopPropagation();
  };

  render() {
    const { open, inputValue, maxCapacityValue, colorValue } = this.state;
    const {
      btnIcon: IconComponent,
      btnTitle,
      btnIconColor,
      btnSize,
      modalTitle = 'Input Data Modal',
      modalOkText = 'Guardar',
      modalCancelText = 'Cancelar',
      inputPlacehoder = 'Ingresa el valor...',
      numberPlaceholder = 'Ingresa un maximo de alumnos...',
      selectPlaceholder = 'Selecciona una opción...'
    } = this.props;

    return (
      <div onClick={this.stopEvent}>
        <IconGhostBtn
          icon={IconComponent}
          btnIconColor={btnIconColor}
          btnSize={btnSize}
          btnTitle={btnTitle}
          onClick={(e) => this.showModal(e)}
        />
        <Modal
            title={modalTitle}
            visible={open}
            onOk={(e)=>this.handleOk(e)}
            onCancel={(e)=>this.handleCancel(e)}
            okText={modalOkText}
            cancelText={modalCancelText}
            maskClosable={false}
            closable={false}
        >
              <Input
                value={inputValue  || undefined}
                onChange={(e)=>this.handleChangeInput(e)}
                placeholder={inputPlacehoder}
                style={{ marginBottom: 12 }}
              />
              {/* Input numérico */}
              <InputNumber
                value={maxCapacityValue || undefined}
                min={1}
                max={6}
                placeholder={numberPlaceholder}
                style={{ width: '100%', marginBottom: 12 }}
                onChange={this.handleChangeNumber}
              />
              {/* Select con colores */}
              <Select
                value={colorValue|| undefined}
                placeholder={selectPlaceholder}
                onChange={this.handleChangeSelect}
                style={{ width: '100%' }}
              >
                {(TransparentColors || []).map((opt) => (
                  <Select.Option key={opt.value} value={opt.value}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span
                        style={{
                          display: 'inline-block',
                          width: 14,
                          height: 14,
                          backgroundColor: opt.value,
                          borderRadius: '50%',
                        }}
                      />
                      {opt.label}
                    </div>
                  </Select.Option>
                ))}
              </Select>
        </Modal>
      </div>
    );
  }
}
export default IconInputButton;